import React from "react";
import { skipToken } from "@reduxjs/toolkit/query";
import { Card, CheckLabel, CopyHash, LongTextLabel, QueryResult, } from "@sscs/ui";
import { DATE_FIELD_FORMAT, getQueryStatus, humanReadableBytes, } from "@sscs/utils";
import { format, formatDistanceToNowStrict } from "date-fns";
import { Outlet } from "react-router";
import { getFileName, getSha256 } from "../../utils";
import { useLevels } from "../hooks";
import { useGetComponentInfoQuery } from "../services/fileBrowser.api";
import styles from "./fileBrowser.module.scss";
import FileIcon from "./FileIcon";
import SectionRail from "./tabs/SectionRail";
import { useGetFileAndReportId } from "./useGetFileAndReportId";
const FileDetails = () => {
    const { reportId, fileId } = useGetFileAndReportId();
    const { scanLevel, isLevelCustomized } = useLevels();
    const { data, isLoading, isFetching, isError, error } = useGetComponentInfoQuery(fileId
        ? {
            reportId: reportId,
            fileId: fileId,
        }
        : skipToken);
    const sha256 = data ? getSha256(data.info) : "";
    const archTag = data === null || data === void 0 ? void 0 : data.tags.find((tag) => tag.toLowerCase().startsWith("arch"));
    const isComponentNotFound = isError &&
        typeof error === "object" &&
        error !== null &&
        "status" in error &&
        error.status === 404;
    return (React.createElement(QueryResult, { status: getQueryStatus({
            isLoading,
            isFetching,
            isError,
            error,
            data,
        }), errorTitle: isComponentNotFound ? "Could not find selected component." : undefined, errorMessage: isComponentNotFound
            ? "Try selecting another component from the list."
            : undefined }, data && (React.createElement(Card.Card, null,
        React.createElement(Card.Title, { as: "h2", actions: React.createElement(CheckLabel, { scanLevel: scanLevel, status: data.quality.status, isLevelCustomized: isLevelCustomized }), details: [
                `${data.info.type}/${data.info.subtype}${data.info.format ? `/${data.info.format}` : ""}`,
                ...(archTag ? [archTag] : []),
                humanReadableBytes(Number(data.info.size)),
                React.createElement("span", { key: "age", title: data.timestamp &&
                        format(new Date(data.timestamp), DATE_FIELD_FORMAT) }, data.timestamp
                    ? `${formatDistanceToNowStrict(new Date(data.timestamp))} old`
                    : "Undetermined"),
                React.createElement("span", { key: "hash", className: styles["title-hash"] },
                    React.createElement("span", null, "SHA256:"),
                    React.createElement("span", { className: styles["title-hash-value"], title: sha256 }, `${sha256.slice(0, 6)}…${sha256.slice(-6)}`),
                    React.createElement(CopyHash, { id: "file-detail-copy-hash", sha256: sha256 })),
            ] },
            React.createElement("span", { className: styles.title },
                React.createElement(FileIcon, { classification: data.classification.classification, deleted: data.info.deleted, verified: data.identity.verified }),
                React.createElement(LongTextLabel, { label: getFileName(data.info), maxCharacters: 60, inline: true }),
                data.order !== null && data.order > 0 && (React.createElement("span", null,
                    "(",
                    data.order,
                    ")")))),
        React.createElement(Card.Content, { flush: true },
            React.createElement("div", { className: styles.split },
                React.createElement("div", { className: styles.rail },
                    React.createElement(SectionRail, { counters: data.counters, fileClassification: data.classification.classification, worstDependencyClassification: data.worst_dependency_classification })),
                React.createElement("div", { className: styles["file-content"] },
                    React.createElement(Outlet, null))))))));
};
export default FileDetails;
//# sourceMappingURL=FileDetails.js.map